import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {cloneDeep, isEqual} from 'lodash'
import {formatProduct} from './utils'
import {ICouponSt, IUserCouponsReq, IUserCouponsResp} from './service'

export type IActiveBonus = {
  /** 折扣 */
  discount: string
  /** 金币 */
  coins: number
  coins_display: number
  tag: string
  /** 加上额外赠送的金币综合，只有金币聚合的方式读这个 */
  total_coin: number
  total_coin_display: number
  /** 赠送金币数量，只有按金额聚合的方式读取这个 */
  bonus_coin: number
  bonus_coin_display: number
  /** 创建订单透传 */
  activity_type: string
}
export type IChannelItem = {
  /** 支付方式ID */
  pay_method_id: number
  /** 渠道名称 如： checkout */
  channel_name: string
  /** 子渠道名称 如：VISA */
  name: string
  /** 支付icon图标 */
  img?: string
  /** 上回支付成功 */
  last_succeed?: boolean
  /** 官方渠道商品id */
  id: string
  /** 商品id	必须	 */
  product_id: string
  /**  商品价格，不需要做额外处理	必须	*/
  price: number
  /** 商品对应金币数	必须 */
  coins: number
  coins_display: number
  /** 货币单位	必须	“USD”: 美元 */
  currency: string
  /** 优惠价值 */
  discount_amount: string
  /** 排序分 */
  score: number

  tag: string
}

export type ICountry = {
  /** int64 国家代码 */
  code: number
  /** 国家名字 */
  name: string
}

export type IThirdPartyItem = {
  // /** 渠道折扣 */
  // discount: string
  /** 商品对应金币数 */
  coins: number
  coins_display: number
  /** 活动折扣信息	 */
  activity_bonus: IActiveBonus
  /** 该sku可用的支付渠道信息 */
  third_pay_list: IChannelItem[]

  /** h5 */
  channel: IChannelItem[]
  ratio: number
}
export type IWebThirdPartyItem = {
  /** 商品对应金币数 */
  coins: number
  coins_display: number
  /** 活动折扣信息	 */
  activity_bonus: IActiveBonus

  channel_name: string
  currency: string
  /** 渠道折扣 */
  discount_amount: string
  payment_id: string
  price: number | string
  product_id: string
  /** 该sku可用的支付渠道信息 */
  channel: IChannelItem[]
  last_succeed: boolean
  ratio: number
}

export type IProductsReq = {
  /** 国家代码 */
  country_code?: string | number
  /** 快捷支付展示场景 */
  from?: string
  /** 需要额外x金币	 */
  need_coins?: number
  is_quick: boolean
  activity_opt?: {
    return_user_type: -1 | 1 | 2 | 3 // 1-无价值老用户 2-普通价值老用户 3-尊贵老用户 -1-非回流老用户
    show_return_user_recharge: boolean // 是否可以展示回归用户充值活动
    return_recharge_et: number // 优惠倒计时
    exp_group: boolean // 0-对照组 1-实验组
  }
}
export type IOfficeChannelItem = {
  activity_bonus: any
  coins: number
  coins_display: number
  currency: string
  dt: number
  id: string
  out_code: string
  price: number
  product_id: string
  type: string
}
export type IProductsResp = {
  /** 是否可以查看币商列表 */
  can_show_agency_list: boolean
  list: IOfficeChannelItem[]
  coins: number
  coins_display: number
  /** 0.没充值过 1.充值过  */
  is_recharged: boolean
  third_party_list: IThirdPartyItem[]
  // 币商排序分
  ra_score?: number
  // 是否可以选择国家（在白名单内）
  country_select_white?: boolean
  /** 国家列表 */
  countries: ICountry[]
  /** 默认国家 */
  default_country: ICountry
  huawei_list: any[]
  /** 是否是首充用户 */
  is_first_recharge: boolean
  /** chat业务充值额外奖励说明页地址 */
  extra_desc_url: string
  /** 是否是审核版本，如果是审核版本，需要屏蔽掉页面上的审核敏感内容 */
  is_audit_ver: boolean
  /** 是否弹反馈窗口 */
  show_feedback_popup: boolean
  /** 快捷弹窗场景文案 */
  desc: string
  /** 排序实验 */
  order_exp: boolean
  /** 需要填写个人信息的渠道 dreamo相关渠道 */
  need_info_channel: string[]
  /**
   ** 0 金币聚合展示 对照组
   ** 1 支付金额聚合展示+额外加多少金币 实验组1
   ** 2 支付金额聚合展示+显示sku有多少金币 实验组2
   */
  pay_page_exp_type: number
  /** ab实验标签 埋点用 例如："pay_page_show_richexp2" 透传即可 */
  abt: string
  third_party_list_v3: IThirdPartyV3Item[]
  ra_trade_info?: {
    max_coins: number
    min_coins: number
    max_coins_display: number
    min_coins_display: number
  }
  /** 是否展示卡券入口 */
  show_coupon: boolean
  /** 充值优惠 */
  activity_discount?: {
    /** 限制时间 */
    server_time: number
    /** 回流老用户优惠信息 */
    return_recharge_cfg: Record<
      string,
      {
        activity: string
        bonus_coin: number
        bonus_coin_display: number
        currency: string
        extra_amount: 149
        limit: number
        num: number
        pay_amount: number
        ratio: number
        total_coin: number
        total_coin_display: number
        official_ids: string[]
        third_party_product_ids: string[]
      }
    >
  }
}

export type IThirdPartyV3Item = {
  /**
   * discount	string	渠道折扣	
当三方渠道金币单位价值低于官方渠道有值，（-20%为"20"）
currency	string	货币单位	必须	“USD”: 美元
price	int64	商品价格，不需要做额外处理	必须	
activity_bonus

ActivityBonusSt

活动折扣信息	可选	对应sku有折扣时存在-开业大酬宾
third_pay_list

[]ThirdPartyInfoSt

该sku可用的支付渠道信息	必需
   */
  discount: string
  currency: number
  price: number
  activity_bonus: IActiveBonus
  third_pay_list: IChannelItem[]
}

export const query_order_h5 = createAsyncThunk(
  '/live/pay/query_order_h5',
  async (params: {order_id: string}, store: any) => {
    const resp = await http.post<{data: any}>(
      `/live/pay/query_order_h5`,
      {
        ...store.getState().env.deviceinfo,
        ...params,
      },
      {
        xcErrorToast: true,
      }
    )

    return resp.data.data
  }
)

export const get_products_list_v2 = createAsyncThunk(
  '/live/pay/get_products_list_v2',
  async (productsReq: IProductsReq, store: any) => {
    const resp = await http.post<{data: IProductsResp}>(
      `/live/pay/get_products_list_v2`,
      {
        ...store.getState().env.deviceinfo,
        ...productsReq,
      }
    )

    return resp.data.data
  }
)

export type IProfileResp = {
  /** 是否币商 */
  is_recharge_agency: boolean
  /** 是否公开余额 */
  is_coin_public: boolean
  /** 交易说明 */
  trade_remark: string
  /** 币商金币数	 */
  agency_coins: number
  agency_coins_display: number
  /** WhatsApp信息列表 */
  whats_app_infos: {
    /** 国家码 */
    country_code: string
    /** 手机号码 */
    phone: string
  }[]
}

// /** /live/account/profile */
// export const getProfile = createAsyncThunk(
//   '/live/account/profile',
//   async (params, store: any) => {
//     const resp = await http.post<{data: IProfileResp}>(
//       '/live/account/profile',
//       {
//         ...store.getState().env.deviceinfo,
//       }
//     )

//     return resp.data.data
//   }
// )
export const getProfile = createAsyncThunk(
  '/live/pay/recharge_agency_profile',
  async (params, store: any) => {
    const resp = await http.post<{data: IProfileResp}>(
      '/live/pay/recharge_agency_profile',
      {
        ...store.getState().env.deviceinfo,
      }
    )

    return resp.data.data
  }
)

/** 获取优惠卡券信息 */
export const getUserCoupons = createAsyncThunk(
  '/live/pay/get_user_coupons',
  async (params: IUserCouponsReq, store: any) => {
    const resp = await http.post<{data: IUserCouponsResp}>(
      '/live/pay/get_user_coupons',
      {
        ...store.getState().env.deviceinfo,
        name: 'Weekly recharge',
        limit: 100,
        ...params,
      }
    )
    return resp.data.data
  }
)

const initialState: {
  curPage: string
  curProduct: IThirdPartyItem & IWebThirdPartyItem
  curChannel: IChannelItem & {tag: string; id: string}
  productList: (IThirdPartyItem & IWebThirdPartyItem)[]
  productListResp: IProductsResp
  curCountry: ICountry
  h_dt?: number
  account: IProfileResp
  isProductListFetched: boolean
  couponList: ICouponSt[]
} = {
  curPage: 'wallet',
  curProduct: {} as IThirdPartyItem & IWebThirdPartyItem,
  curChannel: {} as IChannelItem & {tag: string; id: string},
  productList: [],
  productListResp: {
    list: [],
    coins: 0,
    coins_display: 0,
    is_recharged: false,
    third_party_list: [],
    countries: [],
    ra_score: 0,
    country_select_white: false,
    default_country: {
      code: undefined,
      name: '',
    },
    huawei_list: [],
    is_first_recharge: false,
    extra_desc_url: '',
    is_audit_ver: false,
    show_feedback_popup: false,
    desc: '',
    can_show_agency_list: false,
    order_exp: false,
    need_info_channel: [],
    pay_page_exp_type: 0,
    abt: '',
    third_party_list_v3: [],
    show_coupon: false,
  },
  curCountry: {} as ICountry,
  h_dt: undefined,
  account: {
    is_recharge_agency: false,
    is_coin_public: false,
    trade_remark: '',
    agency_coins: 0,
    agency_coins_display: 0,
    whats_app_infos: [],
  },
  isProductListFetched: false,
  couponList: [],
}

export const WalletAdvancedSlice = createSlice({
  name: 'WalletAdvanced',
  initialState,
  reducers: {
    setCurPage: (state, action) => {
      Object.assign(state, {curPage: action.payload})
    },
    setCurProduct: (state, action) => {
      // 同时重置channel信息
      Object.assign(state, {curProduct: action.payload})
    },
    setCurChannel: (state, action) => {
      Object.assign(state, {curChannel: action.payload})
    },
    setCurCountry: (state, action) => {
      Object.assign(state, {curCountry: action.payload})
    },
    setDt: (state, action) => {
      Object.assign(state, {h_dt: action.payload})
    },
  },
  extraReducers: (builder) => {
    builder.addCase(get_products_list_v2.fulfilled, (state, action) => {
      const resp = action.payload
      const {
        list,
        coins,
        coins_display,
        is_recharged,
        third_party_list,
        countries,
        default_country,
        huawei_list,
        is_first_recharge,
        extra_desc_url,
        is_audit_ver,
        show_feedback_popup,
        desc,
        can_show_agency_list,
        order_exp,
        need_info_channel,
        pay_page_exp_type,
        abt,
        third_party_list_v3,
        show_coupon,
        ra_score,
        country_select_white,
        ra_trade_info,
      } = resp
      Object.assign(state, {
        productListResp: {
          list,
          coins,
          coins_display,
          is_recharged,
          third_party_list: third_party_list || [],
          countries: countries || [],
          default_country: default_country || {},
          huawei_list,
          is_first_recharge,
          extra_desc_url,
          is_audit_ver,
          show_feedback_popup,
          desc,
          can_show_agency_list,
          order_exp,
          need_info_channel,
          pay_page_exp_type,
          abt,
          third_party_list_v3: third_party_list_v3 || [],
          show_coupon,
          ra_score,
          country_select_white,
          ra_trade_info,
        },
        isProductListFetched: true,
      })
      const formatList = cloneDeep(formatProduct(resp, state.h_dt))
      if (!isEqual(formatList, state.productList)) {
        Object.assign(state, {productList: formatList})
      }
      // Object.assign(state, {productList: formatList})
    })

    builder.addCase(getProfile.fulfilled, (state, action) => {
      const res = action.payload
      Object.assign(state.account, {
        ...res,
      })
    })

    builder.addCase(getUserCoupons.fulfilled, (state, action) => {
      const {coupon_list} = action.payload
      Object.assign(state, {
        couponList: coupon_list,
      })
    })
  },
})

export default WalletAdvancedSlice.reducer

export const WalletAdvancedActions = WalletAdvancedSlice.actions
export const useWalletAdvancedState = () => {
  const data = useSelector((state) => {
    return state.WalletAdvanced
  })
  return data
}
